var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"calendar",staticClass:"container vld-parent"},[_c('full-calendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }